/* eslint-disable */
export default {
	getTextbook: {
		// path: '/plan/camp/chapter',
		path: 'p/{pid}/chapter',
		restful: true
	},
	getChapterById: {
		path: '/interact/resource/{id}',
		// path: 'p/{cpid}/resource/{id}',
		restful: true
	},
	deleteChapterCollect: {
		path: 'p/{cpid}/resource/{id}/collection',
		method: 'delete',
		restful: true
	},
	completeChapterRead: {
		path: 'p/{plan_id}/chapter/{resource_id}/finished',
		method: 'post',
		restful: true
	},
	getChapterCatalog: {
		path: 'p/{pid}/chapter/catalog',
		restful: true
	}
};



// WEBPACK FOOTER //
// ./src/modules/textbook/apis.js